import { useCallback, useState } from "react";
import MessageFeedback from "./MessageFeedback";
import useHermesAnalytics from "@containers/Hermes/hooks/useHermesAnalytics";

type MessageActionsProps = {
  content: string;
  messageId: number;
  conversationId: string;
};

const ICON_BTN = "tw-flex tw-items-center tw-justify-center tw-w-7 tw-h-7 tw-rounded-md tw-border-none tw-bg-transparent tw-cursor-pointer tw-text-gray-400 hover:tw-text-gray-600 hover:tw-bg-gray-50 tw-transition-colors tw-duration-150";

export default function MessageActions({ content, messageId, conversationId }: MessageActionsProps) {
  const [copied, setCopied] = useState(false);
  const analytics = useHermesAnalytics();

  const handleCopy = useCallback(() => {
    if (!navigator.clipboard) return;
    navigator.clipboard.writeText(content).then(() => {
      setCopied(true);
      analytics.responseCopied({ conversationId, messageId });
      window.setTimeout(() => setCopied(false), 1500);
    });
  }, [content, analytics, conversationId, messageId]);

  return (
    <div className="tw-flex tw-items-center tw-justify-between tw-mt-3">
      <div className="tw-flex tw-items-center tw-gap-1">
        <button onClick={handleCopy} aria-label="Copy response" title={copied ? "Copied" : "Copy"} className={ICON_BTN}>
          {copied ? (
            <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 -960 960 960" width="20" fill="currentColor" className="tw-text-gray-900">
              <path d="M382-240 154-468l57-57 171 171 367-367 57 57-424 424Z" />
            </svg>
          ) : (
            <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 -960 960 960" width="20" fill="currentColor" className="tw-text-gray-900">
              <path d="M360-240q-33 0-56.5-23.5T280-320v-480q0-33 23.5-56.5T360-880h360q33 0 56.5 23.5T800-800v480q0 33-23.5 56.5T720-240H360Zm0-80h360v-480H360v480ZM200-80q-33 0-56.5-23.5T120-160v-560h80v560h440v80H200Zm160-240v-480 480Z" />
            </svg>
          )}
        </button>
      </div>

      <MessageFeedback messageId={messageId} conversationId={conversationId} />
    </div>
  );
}
